import React, { createContext, useContext, useState, ReactNode } from "react";
import { useOidcUser } from "@axa-fr/react-oidc";
import { UserType } from "#/api/oidc/oidcConfig";
import { UseQueryResult } from "react-query";
import { AxiosError } from "axios";
import { useGetRedeemPoints } from "#/requests/get-redeem-points";
import { RedeemPoints } from "#/api/partnersShowcase/types";

interface PointsContextType {
  points: UseQueryResult<RedeemPoints, AxiosError>;
  refreshPoints: () => void;
}

const PointsContext = createContext<PointsContextType | null>(null);

interface PointsProviderProps {
  children: ReactNode;
}

export const PointsProvider: React.FC<PointsProviderProps> = ({ children }) => {
  const { oidcUser } = useOidcUser<UserType>();
  const cpf = oidcUser?.cpf;
  const cnpj = oidcUser?.cnpj;
  const accountSource = oidcUser?.brand;
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const points = useGetRedeemPoints({
    cpf,
    accountSource,
    cnpj,
    refreshTrigger,
    options: {
      enabled: Boolean(cpf),
    },
  });

  const refreshPoints = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <PointsContext.Provider value={{ points, refreshPoints }}>
      {children}
    </PointsContext.Provider>
  );
};

export const usePoints = () => {
  return useContext(PointsContext);
};
